<template>
  <div class="d-flex align-start tracking-box">
    <div :class="['field-group', {'field-error':!!track.validation.pnr}]">
      <!-- <label class="field-label">PNR</label> -->
      <input type="text" placeholder="PNR/Reservation number here"
        :disabled="buttonLoading" v-model="track.pnr" @change="trackRevalidate('pnr')"
        :class="['field-text', {disabled:buttonLoading, highlight:highlight === 'pnr'}]" />
      <div class="text-right error-box">
        <span class="field-error-message">{{track.validation.pnr}}</span>
      </div>
    </div>

    <div :class="['field-group', {'field-error':!!track.validation.firstName}]">
      <!-- <label class="field-label">First Name</label> -->
      <input type="text" placeholder="First Name"
        :disabled="buttonLoading" v-model="track.firstName" @change="trackRevalidate('firstName')"
        :class="['field-text', {disabled:buttonLoading, highlight:highlight === 'firstName'}]" />
      <div class="text-right error-box">
        <span class="field-error-message">{{track.validation.firstName}}</span>
      </div>
    </div>

    <div :class="['field-group', {'field-error':!!track.validation.lastName}]">
      <!-- <label class="field-label">Last Name</label> -->
      <input type="text" placeholder="Last Name" v-on:keyup.enter="trackRsvp"
        :disabled="buttonLoading" v-model="track.lastName" @change="trackRevalidate('lastName')"
        :class="['field-text', {disabled:buttonLoading, highlight:highlight === 'lastName'}]" />
      <div class="text-right error-box">
        <span class="field-error-message">{{track.validation.lastName}}</span>
      </div>
    </div>

    <a @click="trackRsvp" :class="['op-btn btn-md btn-block btn-black search-submit', {'disabled':buttonLoading}]">
      <span v-if="!buttonLoading">Track</span>
      <span v-else><i class="fa fa-spinner fa-spin"></i> Loading</span>
    </a>
  </div>
</template>

<script>
/* global CONFIG */
import moment from 'moment'
import ft from '@/modules/api/featureToggle'
import ApiRsvpSearch from '@/modules/api/reservation-search'

export default {
  name: 'tracking-form',
  data () {
    return {
      highlight: '',
      track: {
        pnr: '',
        firstName: '',
        lastName: '',
        validation: {
          pnr: '',
          firstName: '',
          lastName: ''
        }
      },
      varFixer: ''
    }
  },
  computed: {
    rsvpData () { return this.$store.state.reservation },
    airlineLoading () { return this.rsvpData.airlineLoading },
    buttonLoading () { return this.airlineLoading }
  },
  methods: {
    trackRevalidate (field) {
      if (this.track[field]) this.track.validation[field] = ''
    },
    trackRsvp () {
      let self = this
      self.track.validation = {
        pnr: '',
        firstName: '',
        lastName: ''
      }
      let fields = ['pnr', 'firstName', 'lastName']
      let hasError = false
      fields.forEach(f => {
        if (!self.track[f]) {
          hasError = true
          self.track.validation[f] = this.$t('common.fieldEmpty')
        }
      })
      if (hasError) return
      self.$store.commit('global/setLoaderData', {show: true})
      self.$sdk.post2(`${CONFIG.d2dGateway}/d2d/guest`, {
        pnr: self.track.pnr,
        firstName: self.track.firstName,
        lastName: self.track.lastName,
        raw: true
      }, r => {
        if (r.error) {
          self.$store.commit('global/setLoaderData', {show: false})
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.error.message
          })
          return
        }
        if (!r.list.length) {
          self.checkGroundBooking()
          // self.$store.commit('global/setLoaderData', {show: false})
          // self.$store.commit('global/setAlertData', {
          //   show: true,
          //   message: 'Unable to find your reservation. Please ensure you entered the correct Airline PNR and name exactly as it appears on your booking confirmation.'
          // })
          return
        }
        self.buildFlightData(r)
      })
    },
    buildFlightData (r) {
      let self = this
      let data = r.list[0]
      let tmp = {
        id: data.id,
        bookingId: data.bookingId,
        booked: moment(data.createdUTC, 'X').format('MM/DD/YYYY hh:mmA'),
        pnr: data.pnr,
        airFareTotal: data.fareFlightTotal,
        roundtripId: data.roundTripId,
        credits: data.credits || 0,
        flights: {
          oneway: [],
          return: []
        },
        pax: [],
        status: data.status,
        isRefundable: data.isRefundable
      }
      let flightDetails = data.priceData.UpdateFareQuote.FareQuoteDetails.JourneyList.FlightDetails.Details
      flightDetails[0].forEach(f => {
        tmp.flights.oneway.push({
          flightName: f.OperatorName,
          flightCode: f.OperatorCode,
          flightNo: f.FlightNumber,
          duration: f.Duration,
          origin: {
            code: f.Origin.AirportCode,
            name: f.Origin.AirportName,
            date: moment(f.Origin.DateTime, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY hh:mmA')
          },
          destination: {
            code: f.Destination.AirportCode,
            name: f.Destination.AirportName,
            date: moment(f.Destination.DateTime, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY hh:mmA')
          }
        })
      })
      if (data.roundTripId && flightDetails[1]) {
        flightDetails[1].forEach(f => {
          tmp.flights.return.push({
            flightName: f.OperatorName,
            flightCode: f.OperatorCode,
            flightNo: f.FlightNumber,
            duration: f.Duration,
            origin: {
              code: f.Origin.AirportCode,
              name: f.Origin.AirportName,
              date: moment(f.Origin.DateTime, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY hh:mmA')
            },
            destination: {
              code: f.Destination.AirportCode,
              name: f.Destination.AirportName,
              date: moment(f.Destination.DateTime, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY hh:mmA')
            }
          })
        })
      }
      data.commitData.CommitBooking.BookingDetails.PassengerDetails.forEach(p => {
        tmp.pax.push({
          firstName: p.FirstName,
          lastName: p.LastName,
          ticketId: p.TicketId,
          ticketNo: p.TicketNumber
        })
      })
      let currency = {code: 'USD'}
      if (data.currency) {
        currency = {
          code: data.currency.currency,
          flight: data.currency.flight,
          credits: data.currency.credits
        }
      }
      let flightData = {
        selected: tmp,
        currency: currency
      }
      self.$store.commit('flights/setFlightData', flightData)
      let rsvps = []
      let isLeg1 = true
      let availableGround = []
      if (data.roundTripId) isLeg1 = data.id < data.roundTripId
      if (data.rsvpId1) {
        availableGround.push(isLeg1 ? 1 : 3)
        rsvps.push({id: data.rsvpId1, target: isLeg1 ? 'rsvp1' : 'rsvp3'})
      }
      if (data.rsvpId2) {
        availableGround.push(isLeg1 ? 2 : 4)
        rsvps.push({id: data.rsvpId2, target: isLeg1 ? 'rsvp2' : 'rsvp4'})
      }
      if (data.roundTripId && r.list[1]) {
        let data2 = r.list[1]
        isLeg1 = data2.id < data2.roundTripId
        if (data2.rsvpId1) {
          rsvps.push({id: data2.rsvpId1, target: isLeg1 ? 'rsvp1' : 'rsvp3'})
        }
        if (data2.rsvpId2) {
          rsvps.push({id: data2.rsvpId2, target: isLeg1 ? 'rsvp2' : 'rsvp4'})
        }
      }
      self.$store.commit('flights/setFlightData', {availableGround: availableGround})
      // if (rsvps.length) self.getRsvpData(rsvps)
      self.getRsvpData(rsvps)
    },
    getRsvpData (rsvps) {
      let self = this
      if (!rsvps.length) {
        self.$store.commit('global/setLoaderData', {show: false})
        self.$store.commit('flights/setFlightTrackData', {
          enable: true,
          pnr: self.track.pnr,
          firstName: self.track.firstName,
          lastName: self.track.lastName
        })
        document.body.classList.add('widget-full', 'd2d-mode')
        self.$router.push('my-flights')
        return
      }
      let firstName = self.track.firstName
      let lastName = self.track.lastName
      self.$sdk.get(self, `/reservations/${rsvps[0].id}/${firstName}/${lastName}`, {}, r => {
        if (r.error) {
          self.$store.commit('global/setLoaderData', {show: false})
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.error.message
          })
          return
        }
        let tmp = {}
        let total = parseFloat(r.breakdown.total || 0) + (r.gasFee || 0)
        tmp[rsvps[0].target] = {
          id: r.ID,
          service: r.serviceType.label,
          pickup: r.pickupLocation,
          dropoff: r.dropoffLocation,
          pickupDate: moment(r.pickupDate, 'YYYY-MM-DD HH:mm:ss Z').tz(r.pickupTimezone).format('MM/DD/YYYY hh:mmA'),
          payment: total.toFixed(2)
        }
        self.getCurrencyData(tmp, rsvps)
        // self.$store.commit('flights/setFlightData', tmp)
        // rsvps.shift()
        // self.getRsvpData(rsvps)
      })
    },
    getCurrencyData (tmp, rsvps) {
      let self = this
      let firstName = self.track.firstName
      let lastName = self.track.lastName
      self.$sdk.get(self, `/reservations/${rsvps[0].id}/${firstName}/${lastName}/currency`, {}, r => {
        if (!r.error) {
          let total = r.airportFee + r.amount + r.gasFee + r.pickupFee + r.tipAmount + r.travelInsurance
          total -= r.credit
          r.total = parseFloat(total.toFixed(2))
          tmp[rsvps[0].target].currency = r
        }

        self.$store.commit('flights/setFlightData', tmp)
        rsvps.shift()
        self.getRsvpData(rsvps)
      })
    },
    checkGroundBooking () {
      let self = this
      ApiRsvpSearch.search(self, self.track.pnr, self.track.firstName, self.track.lastName, rsvp => {
        self.$store.commit('global/setLoaderData', {show: false})
        if (rsvp.isMtech) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: 'Tracking is not available for this reservation.'
          })
          return
        }

        if (rsvp.dispatchStatus === 'complete') {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: self.$t('searchTrack.rsvpCompleted')
          })
          return
        }

        if (rsvp.dispatchStatus === 'canceled') {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: self.$t('searchTrack.rsvpCancelled')
          })
          return
        }

        if (rsvp.hasExtraStop) {
          self.$sdk.get(self, `/reservations/${self.track.pnr}/${self.track.firstName}/${self.track.lastName}/extrastops`, {}, res => {
            if (!res.error) {
              rsvp.extraStops = res.list
              self.proceedToTrack(rsvp)
            }
          }, '1.1')
        } else {
          this.$store.commit('reservation/setCharterData', {
            enabled: false,
            pickup: {},
            startDate: '',
            endDate: '',
            selectedService: ''
          })
          if (rsvp.isCharter) {
            let starDate = moment(rsvp.pickupTime, 'MM/DD/YYYY ' + ft.timeFormat(self, false))
            self.$store.commit('reservation/setCharterData', {
              enabled: true,
              pickup: rsvp.pickup,
              startDate: starDate.format('MM/DD/YYYY hh:mmA'),
              endDate: starDate.add(rsvp.eta, 'seconds').format('MM/DD/YYYY hh:mmA'),
              selectedService: rsvp.serviceCode
            })
          }
          self.proceedToTrack(rsvp)
        }
      }, error => {
        self.varFixer = error
        self.$store.commit('global/setLoaderData', {show: false})
        self.$store.commit('global/setAlertData', {
          show: true,
          message: 'Unable to find your reservation. Please ensure you entered the correct Airline PNR and name exactly as it appears on your booking confirmation.'
        })
      })
    },
    proceedToTrack (rsvp) {
      let self = this

      self.$store.commit('rsvpTrack/setRsvp', rsvp)
      if (self.showOnLoad) {
        document.body.classList.add('widget-full');
      }
      if (self.getVariable('id')) {
        let cleanUri = location.protocol + '//' + location.host + location.pathname + window.location.hash
        window.history.replaceState({}, document.title, cleanUri)
      }

      self.$root.$router.push('rsvp-track')
      window.location = '#/rsvp-track'
    },
    getVariable (field) {
      let query = window.location.search.substring(1);
      let vars = query.split('&')
      for (let i = 0; i < vars.length; i++) {
        let pair = vars[i].split('=')
        if (pair[0] === field) {
          return pair[1]
        }
      }
      return false
    }
  },
  watch: {
  },
  created () {
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
.tracking-box{
  gap: 10px;
}
.field-group{
  width: calc(33% - 54px);
  input{
    margin-bottom: 0;
  }
}
.search-submit{
  width: 160px;
  min-width: 150px;
}

@media only screen and (max-width: 641px) {
  .tracking-box{
    flex-direction: column;

    .field-group, .search-submit{
      width: 100%;
      margin-bottom: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?8d07c9ae